import { useTranslation } from "react-i18next";

const ConsumerConsent = (props) => {
  const { t } = useTranslation();
  return (
    <div>
      <h4>{t("cc_text")}</h4>
        <p>
            I, <strong>{props?.coBorrowerFullName}</strong>, {t("cc_text1")}
        </p>
        <p>
          {t("cc_text2")}
        </p>
        <p>
          {t("cc_text3")}
        </p>
        <p>
          {t("cc_text4")}
        </p>
        <p>
          {t("cc_text5")}
        </p>
        <p>
          {t("cc_text6")}
        </p>
      {/* <h4>Consumer Consent</h4>
      <br />
      <h5>{props?.coBorrowerFullName}</h5>
      <p>
        By signing this form, I provide explicit instructions
        to Bond Street Mortgage, in accordance with the Fair Credit Reporting
        Act, to access information from my personal credit profile or other
        related details from the three major credit bureaus. I authorize Bond
        Street Mortgage to use this information solely for the purpose of
        prequalifying me for credit options. Furthermore, I grant Bond Street
        Mortgage permission to verify any documents necessary in connection with
        my mortgage application. I acknowledge that the credit information
        obtained for my pre-qualification might differ from the information
        accessed by a credit grantor at a later date for making an actual credit
      </p> */}
    </div>
  );
};

export default ConsumerConsent;
